export const limit = (string, param) => string.length > param ? string.substring(0, param) + '...' : string;
